/**
 * Extended Specs & Details – exclusive accordion
 */
(function () {
  'use strict';

  function initAccordion(root) {
    const items = root.querySelectorAll('[data-esd-item]');
    if (!items.length) return;

    items.forEach((item) => {
      const trigger = item.querySelector('[data-esd-trigger]');
      const panel = item.querySelector('[data-esd-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((other) => {
          const otherTrigger = other.querySelector('[data-esd-trigger]');
          const otherPanel = other.querySelector('[data-esd-panel]');
          other.classList.remove('is-open');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function initSection(sectionRoot) {
    const accordion = sectionRoot.querySelector('[data-esd-accordion]');
    if (accordion && accordion.dataset.esdReady !== 'true') {
      accordion.dataset.esdReady = 'true';
      initAccordion(accordion);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-extended-specs-details]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-extended-specs-details]');
    if (root) initSection(root);
  });
})();
